module.exports = __webpack_public_path__ + "files/415fd65f79f3e2599970a13c6f612740.png";